<template>
  <div class="answer-item">
    <div class="answer-header">
      <div class="title">
        No{{index}}. {{data.title}}
      </div>
      <div class="type">
        单选题
      </div>
    </div>
    <el-radio-group v-model="answer">
      <el-radio
        v-for="(item,index) in data.options"
        :key="index"
        :label="item.id"
      >{{item.text}}</el-radio>
    </el-radio-group>
    <picture-list
      v-if="showPicture"
      :data="data.photos"
    ></picture-list>
    <video-list
      v-if="showVideo"
      :data="data.videos"
    ></video-list>
  </div>
</template>

<script>
import Question from "./Question";
export default {
  mixins: [Question],
  computed: {
    answer: {
      get() {
        return this.data.answer.id[0];
      },
      set() {}
    }
  }
};
</script>
